import styled from "styled-components";

export const TabWrapper = styled.div`
    width: 100%;
    height: auto;
    text-align: left;
    padding-bottom: 5rem;
`;

export const InputFieldWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`;

export const InputFieldLabel = styled.label`
    color: rgba(172, 52, 33, 1);
    font-size: 14px;
`;

export const InputField = styled.input`
    background: none;
    border: none;
    outline: none;
    padding-left: 0;
    font-size: 16px;
    border-bottom: 1.5px solid rgba(172, 52, 33, 0.5);
    height: 40px;
    font-family: inherit;
    border-radius: 0px;
    text-align: left;

    &:focus {
        border-bottom: 1.5px solid rgba(172, 52, 33, 1);
    }
`;

export const InputChoiceWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(172, 52, 33, 0.8);
    height: 40px;
    border-radius: 999em;
    padding: 0.2rem;
    margin: 0.5rem 0;
`;

export const InputChoice = styled.input`
    display: none;
`;

export const InputChoiceItem = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    height: 100%;
    border-radius: 999em;
    overflow: hidden;

    input[type="radio"]:checked + label {
        background-color: rgba(172, 52, 33, 1);
    }
`;

export const InputChoiceLabel = styled.label`
    flex: 1;
    height: 100%;
    cursor: pointer;
    color: white;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ButtonChoiceWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(172, 52, 33, 0.8);
    height: 40px;
    border-radius: 999em;
    padding: 0.2rem;
    margin: 0.5rem 0;
`;

export const ButtonChoice = styled.button<{
    isActive: boolean;
}>`
    flex: 1;
    height: 100%;
    cursor: pointer;
    color: white;
    border: none;
    font-weight: 600;
    background-color: ${(props) => props.isActive ? "rgba(172, 52, 33, 1)" : "transparent"};
    overflow: hidden;
    border-radius: 999em;

    &:hover {
        background-color: rgba(172, 52, 33, 0.5);
    }
`;